import React from 'react';
import { Paper, Grid, Typography } from 'material-ui';
import { withStyles } from 'material-ui/styles';
import classNames from 'classnames';
import currencyFormatter from 'currency-formatter';
import AlertIcon from 'material-ui-icons/Error';
import { translate } from 'react-i18next';
import { DoRender, getCorrectOnlinePay } from '../Utils/shared';
import _get from 'lodash.get';

const styles = theme => ({
    expandIcon: {
        color: theme.palette.primary.main
    },
    bookingTitle: {
        color: theme.palette.primary.main,
        padding: '20px 0 20px 25px',
        fontWeight: 'bold',
        fontSize: '1.2rem',
        borderLeft: '2px solid ' + theme.palette.primary.main
    },
    price: {
        marginTop: '0px',
        marginBottom: '4px',
        fontWeight: 700,
        fontSize: '1.5em',
        color: 'var(--error-color)',
        textAlign: 'right'
    },
    onRequestMessageBox: {
        fontSize: '18px',
        fontWeight: 300,
        marginBottom: '24px',
        marginTop: '8px',
        color: theme.palette.primary.contrastText
    },
    onRequestIcon: {
        color: theme.palette.primary.contrastText,
        transform: 'scale(1.6)',
        float: 'left',
        marginRight: '16px',
        marginTop: '8px'
    },
    error: {
        backgroundColor: theme.palette.background.error
    },
    paperFrame: {
        margin: '40px 0px'
    }
});


function RedLabel({ classes, children }) {
    return (
        <div className={classNames(classes.error, 'InformationPanel InfoRequest')} style={{ minWidth: '360px', width: '100%' }}>
            <div>
                <Grid container>
                    <Grid item xs={12}>
                        <AlertIcon className={classes.onRequestIcon} />
                        <Typography className={classes.onRequestMessageBox} style={{ marginLeft: '60px' }}>
                            {children}
                        </Typography>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
}

class ReservationPricesRender extends React.Component {
    constructor(props) {
        super(props);
        this.currentUser = JSON.parse(localStorage.getItem('user'));
        this.state = {
            loading: false,
            B2bVerPVP: this.currentUser.authorities.includes('B2bVerPVP'),
            cancellationInsurance: props.cancellationInsurance
        };
    }

    /**
     *  Return true if reservation is onRequest.
     * Checks hotel.onrequest when user try to make a reserve.
     * Checks reservation.state when user query a reserve.
     * reservation
     * @param reservation the reservation
     * @return bool
     */
    isReservationOnRequest(reservation) {
        let selectedOptions = '';
        if (reservation && reservation.valuationResult && reservation.valuationResult.onrequest) {
            return true;
        }
        if (reservation && reservation.state && reservation.state === 'P') {
            return true;
        }
        if (reservation && reservation.rooms && reservation.rooms.length) {
            const bookingMode = window.location.href.indexOf('#/bookings') !== -1;
            selectedOptions = reservation && bookingMode ? Object.values(reservation.rooms).map(r => r.roomStatus) : Object.values(reservation.rooms).map(r => r.available);

            if (selectedOptions) {
                return selectedOptions.some(roomoption => String(roomoption) === 'RQ');
            }
        }
        return false;
    }

    getPVPLabel = () => {
        if (this.props.onlyShowPVP) {
            return 'CONFIRM_MODIFY_BOOKING.TOTAL_BOOKING';
        }
        return 'CONFIRM_MODIFY_BOOKING.TOTAL_BOOKING_PVP';
    }

    onlyRenderPVPPrice(prices) {
        const { reservation, pvpPriceFormatted, salesPriceFormatted, displayToolTip, cancellationInsurance } = prices;        
        let toolTip = '';
        if (displayToolTip) {
            toolTip = this.props.t('CONFIRM_MODIFY_BOOKING.TOTAL_BOOKING_NET') + ': ' + salesPriceFormatted;
        }
        return (
            <div>
                <Grid container item xs={12}>
                    <Grid item xs={8} >
                        <Typography variant={'title'}>
                            <div>
                                {this.props.t(this.getPVPLabel()) + ':'}
                            </div>
                        </Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography variant={'title'}>
                            <div className={this.props.classes.price} title={toolTip} >
                                {pvpPriceFormatted}
                            </div>
                        </Typography>
                    </Grid>
                </Grid>
                {reservation && ((reservation.cancellationInsuranceAcepted && cancellationInsurance) || (reservation.hotel && reservation.hotel.cancellationInsuranceAcepted && cancellationInsurance)) &&
                    <div>
                        {this.rendercancellationInsurancePrice(cancellationInsurance.price, reservation.pvp)}
                    </div>
                }
            </div>
        );
    }

    onlyRenderSalesPrice(prices) {
        const { reservation, salesPriceFormatted, cancellationInsurance } = prices;
        return (
            <div>
                <Grid container item xs={12} className="cmsNetoReserva">
                    <Grid item xs={6} >
                        <Typography variant={'title'}>
                            <div>
                                {this.props.t('CONFIRM_MODIFY_BOOKING.TOTAL_BOOKING_NET') + ':'}
                            </div>
                        </Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography variant={'title'} s>
                            <div className={this.props.classes.price}>
                                {salesPriceFormatted}
                            </div>
                        </Typography>
                    </Grid>
                </Grid>
                {reservation && ((reservation.cancellationInsuranceAcepted && cancellationInsurance) || (reservation.hotel && reservation.hotel.cancellationInsuranceAcepted && cancellationInsurance)) &&
                    <div>
                        {this.rendercancellationInsurancePrice(cancellationInsurance.price, reservation.price)}
                    </div>
                }
            </div>
        );
    }

    rendercancellationInsurancePrice(cancellationInsurancePrice, bookingPrice, reservation) {
        const total = Number(cancellationInsurancePrice) + Number(bookingPrice);
        const totalFormatted = currencyFormatter.format(total, { code: 'EUR' });
        const cancellationInsurancePriceFormatted = currencyFormatter.format(cancellationInsurancePrice, { code: 'EUR' });
        return (
            <div>
                <Grid container className="cmsNetoCancelationPrice" item xs={12}>
                    <Grid item xs={6}>
                        <Typography variant={'title'}>
                            <div>
                                {this.props.t('CONFIRM_BOOKING.CANCELLATION_INSURANCE_PRICE') + ':'}
                            </div>
                        </Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography variant={'title'} s>
                            <div className={this.props.classes.price}>
                                {cancellationInsurancePriceFormatted}
                            </div>
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container item xs={12} className="cmsFinalPrice">
                    <Grid item xs={6}>
                        <Typography variant={'title'}>
                            <div>
                                {this.props.t('CONFIRM_BOOKING.TOTAL_TO_PAY') + ':'}
                            </div>
                        </Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography variant={'title'} s>
                            <div className={this.props.classes.price}>
                                {totalFormatted}
                            </div>
                        </Typography>
                    </Grid>
                </Grid>
            </div>
        );
    }

    renderFullPVPPrice(prices) {
        const { reservation, pvpPriceFormatted, salesPriceFormatted, cancellationInsurance } = prices;
        return (
            <div>
                <Grid container item xs={12}>
                    <Grid item xs={8}>
                        <Typography variant={'title'}>
                            <div>
                                {this.props.t('CONFIRM_MODIFY_BOOKING.TOTAL_BOOKING_PVP') + ':'}
                            </div>
                        </Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography variant={'title'}>
                            <div className={this.props.classes.price}>
                                {pvpPriceFormatted}
                            </div>
                        </Typography>
                    </Grid>
                    <Grid item xs={8} >
                        <Typography variant={'title'}>
                            <div>
                                {this.props.t('CONFIRM_MODIFY_BOOKING.TOTAL_BOOKING_NET') + ':'}
                            </div>
                        </Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography variant={'title'} s>
                            <div className={this.props.classes.price}>
                                {salesPriceFormatted}
                            </div>
                        </Typography>
                    </Grid>
                </Grid>
                {reservation && ((reservation.cancellationInsuranceAcepted && cancellationInsurance) || (reservation.hotel && reservation.hotel.cancellationInsuranceAcepted && cancellationInsurance)) &&
                    <div>
                        {this.rendercancellationInsurancePrice(cancellationInsurance.price, reservation.price)}
                    </div>
                }
            </div>
        );
    }

    render() {
        const { reservation, classes, t, displayToolTip, cancellationInsurance, onlinePay, cancellationInsuranceAcepted } = this.props;
        const onlyShowPVP = this.props.onlyShowPVP ? this.props.onlyShowPVP : false;
        const onlyShowSalesPrice = this.props.onlyShowSalesPrice ? this.props.onlyShowSalesPrice : false;
        let salesPriceFormatted = 0;
        let pvpPriceFormatted = 0;        

        if (reservation) {
            if (reservation.valuationResult || reservation.price) { // Detalle de reserva
                salesPriceFormatted = currencyFormatter.format(reservation.price, { code: 'EUR' });
                pvpPriceFormatted = currencyFormatter.format(reservation.pvp, { code: 'EUR' });
            } else { // Confirmacion de modificacion.
                let salesPrice =
                    reservation && reservation.rooms
                        ? reservation.rooms.reduce((acc, r) => acc + (Number(r.price) ? Number(r.price) : 0), 0)
                        : 0;

                let retailPrice =
                    reservation && reservation.rooms
                        ? reservation.rooms.reduce((acc, r) => acc + (Number(r.retailPrice) ? Number(r.retailPrice) : 0), 0)
                        : 0;

                salesPriceFormatted = currencyFormatter.format(salesPrice, { code: 'EUR' });
                pvpPriceFormatted = currencyFormatter.format(retailPrice, { code: 'EUR' });
            }

        }
        const prices = {
            reservation: reservation,
            salesPriceFormatted: salesPriceFormatted,
            pvpPriceFormatted: pvpPriceFormatted,
            cancellationInsurance: cancellationInsurance,
            displayToolTip: displayToolTip
        };
        const rooms = _get(reservation, 'valuationResult.hotels[0].rooms', []);
        const amountToPayWithCard = onlinePay ? onlinePay.payInsurance && cancellationInsuranceAcepted ? onlinePay.amountWithInsurance : onlinePay.amount : 0;
        const amountToPayWithCardFormatted = onlinePay ? currencyFormatter.format(amountToPayWithCard, { code: 'EUR' }) : 0;
        // const { pay } = getCorrectOnlinePay(rooms);
        return (
            <Paper className={classes.paperFrame}>
                <Typography className={classes.bookingTitle}>
                    {t('CONFIRM_MODIFY_BOOKING.PRICES_DETAILS')}
                </Typography>
                <Grid container spacing={40} xs={12}>
                    <Grid container item xs={5}>
                        {this.state.B2bVerPVP && !onlyShowSalesPrice ? (
                            onlyShowPVP || displayToolTip ? (
                                this.onlyRenderPVPPrice(prices)
                            ) : (
                                    this.renderFullPVPPrice(prices)
                                )
                        ) : (this.onlyRenderSalesPrice(prices))}
                    </Grid>

                    <DoRender if={reservation && this.isReservationOnRequest(reservation)}>
                        <RedLabel classes={classes}>
                            {t('CONFIRM_BOOKING.ROOM_ON_REQUEST_TITLE_MESSAGE')}
                            <span style={{ fontWeight: 400 }}>{t('CONFIRM_BOOKING.ROOM_ON_REQUEST_SUBTITLE_MESSAGE')}</span>
                        </RedLabel>
                    </DoRender>

                    <DoRender if={onlinePay && onlinePay.pay && amountToPayWithCard > 0.05}>
                        <RedLabel classes={classes}>
                            {t('CONFIRM_BOOKING.NEED_CARD_PAYMENT_MESSAGE')}
                            <div style={{ marginLeft: 0, marginTop:10, fontWeight: 500}}>
                            {t('CONFIRM_BOOKING.PRICE_TO_PAY_WITH_CARD')} {amountToPayWithCardFormatted}
                            </div>
                        </RedLabel>                        
                    </DoRender>
                </Grid>
            </Paper>
        );
    }
}
export default translate('translations')(withStyles(styles)(ReservationPricesRender));



// WEBPACK FOOTER //
// ./src/components/Reservation/ReservationPricesRender.js